import { Component, Watch } from 'vue-property-decorator';
import StudioModal from '@/components/modals/StudioModal.vue';
import { Tabs, Button } from 'streamlabs-beaker';
import { ITab } from '@/helpers/utils';
import { EModalName } from '@/helpers/modal';
import EditorBase from '../editor/EditorBase';
import { codemirror } from 'vue-codemirror';
import NotificationHelper from '@/helpers/notification';

import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/theme/material.css';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closetag';
import 'codemirror/addon/comment/comment';
import 'codemirror/mode/css/css';
import 'codemirror/keymap/sublime';

enum ECodeEditorTabs {
  customHtml = 'custom Html',
  customCss = 'custom CSS',
  // customJs = 'custom JS',
}

@Component({
  components: {
    StudioModal,
    STabs: Tabs,
    SButton: Button,
    codemirror,
  },
})
export default class CodeEditorModal extends EditorBase {
  customHtml: string = null;
  customCss: string = null;
  customJs: string = null;

  loadCustomCode() {
    if (!this.selectedComponent) return;
    this.customHtml = this.selectedComponent.customHtml || null;
    this.customCss = this.selectedComponent.customCss || null;
    this.customJs = this.selectedComponent.customJs || null;
  }

  get modalName(): string {
    return EModalName.codeEditor;
  }

  get tabs(): ITab[] {
    return Object.keys(this.ECodeEditorTabs).map((tab) => {
      return { name: ECodeEditorTabs[tab].toUpperCase(), value: tab };
    });
  }

  get ECodeEditorTabs() {
    return ECodeEditorTabs;
  }

  get editorOptionsHtml() {
    // codemirror options
    return {
      mode: 'htmlmixed',
      keyMap: 'sublime',
      lineNumbers: true,
      autofocus: false,
      tabSize: 2,
      theme: 'material',
      autoRefresh: true,
      autoCloseBrackets: true,
      matchBrackets: true,
      autoCloseTags: true,
      extraKeys: {
        Tab: 'emmetExpandAbbreviation',
        Enter: 'emmetInsertLineBreak',
      },
    };
  }

  get editorOptionsCss() {
    // codemirror options
    return {
      mode: 'text/css',
      keyMap: 'sublime',
      lineNumbers: true,
      autofocus: false,
      tabSize: 2,
      theme: 'material',
      autoRefresh: true,
      autoCloseBrackets: true,
      matchBrackets: true,
      autoCloseTags: true,
      extraKeys: {
        Tab: 'emmetExpandAbbreviation',
        Enter: 'emmetInsertLineBreak',
      },
    };
  }

  get editorOptionsJs() {
    // codemirror options
    return {
      mode: 'javascript',
      keyMap: 'sublime',
      lineNumbers: true,
      autofocus: false,
      tabSize: 2,
      theme: 'material',
      autoRefresh: true,
      autoCloseBrackets: true,
      matchBrackets: true,
      autoCloseTags: true,
    };
  }

  beforeClose() {
    this.customHtml = null;
    this.customCss = null;
    this.customJs = null;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  updateComponent() {
    if (this.customHtml?.toLowerCase().includes('<iframe')) {
      NotificationHelper.error('Iframe elements are not supported.');
      return;
    }

    const data = {
      customHtml: this.customHtml,
      customCss: this.customCss,
      // customJs: this.customJs,
    };
    this.onComponentUpdate({ ...this.selectedComponent, ...data });
    this.hideModal();
    this.preventComponentDeactivate = false;
  }
}
